var map = {
	"./papsi_avatar.svg": 2518,
	"./papsi_back.svg": 9002,
	"./papsi_back_dark.svg": 7954,
	"./papsi_ck_off.svg": 5254,
	"./papsi_ck_on.svg": 9155,
	"./papsi_company.svg": 823,
	"./papsi_edit.svg": 965,
	"./papsi_election.svg": 9757,
	"./papsi_error.svg": 9779,
	"./papsi_help.svg": 4976,
	"./papsi_home.svg": 590,
	"./papsi_list.svg": 3935,
	"./papsi_logout.svg": 184,
	"./papsi_menu.svg": 6148,
	"./papsi_password_invisible.svg": 7426,
	"./papsi_password_visible.svg": 7942,
	"./papsi_pencil.svg": 6090,
	"./papsi_selected.svg": 2884,
	"./papsi_settings.svg": 1301,
	"./papsi_star_off.svg": 484,
	"./papsi_star_on.svg": 1417,
	"./papsi_success.svg": 8903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5816;